// AUTO-GENERATED from apps/global/region.config.js — do not edit here.
// Global edition (India + rest of world) — region configuration.
// Source of truth lives in /apps/global; synced into src/regions/ by
// scripts/sync-regions.js (CRA cannot import from outside src/).
const globalConfig = {
  id: "global",
  label: "India & Global",
  countries: ["*"],
  locale: "en-IN",
  currency: {
    code: "INR",
    symbol: "₹",
    format: (amount) =>
      new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
      }).format(amount),
  },
  phone: {
    placeholder: "+91 XXXXX XXXXX",
    countryCode: "+91",
  },
  contact: {
    email: "info@terces.io",
    whatsapp: true,
    whatsappLink: "https://wa.me/919281115822",
    showPhone: true,
    phoneDisplay: "+91 928 111 5822",
    phoneTel: "tel:+919281115822",
  },
  address: {
    lines: ["Warangal, Telangana,", "India"],
    note: "Serving clients across India and around the world",
  },
  terminology: {
    cloudKitchen: "cloud kitchen",
    cloudKitchens: "cloud kitchens",
    deliveryPlatforms: "Swiggy & Zomato",
  },
  content: {
    heroTag: "Data-Driven Restaurant Consulting",
    heroTagline: "Helping restaurants across India & the world grow smarter",
    marketNoun: "restaurants across India and worldwide",
    caseStudiesIntro:
      "Real results from Terces Solutions engagements: cost reduction, multi-location expansion, digital transformation, and franchise growth across India.",
    caseStudyRegionNote:
      "Real transformations from restaurants across India.",
    currencyExample: "₹2.4L",
    footerBlurb:
      "India's premier restaurant consulting firm — helping F&B businesses in India and worldwide scale with systems, not guesswork.",
    footerTagline: "Crafted with excellence in India",
    adBudgetAnswer:
      "We recommend a minimum of ₹15,000-20,000 per month for effective campaigns. This covers ad spend and management. We can scale based on your goals and results.",
    revenueRanges: [
      "Under ₹5L",
      "₹5L – ₹20L",
      "₹20L – ₹50L",
      "₹50L – ₹1Cr",
      "Above ₹1Cr",
    ],
    careersBlurb:
      "Join Terces Solutions and help transform food businesses across India and beyond. Explore open roles in restaurant consulting, operations, and technology.",
  },
  seo: {
    titleSuffix: "Terces Solutions — F&B Process & Technology Experts",
    homeTitle: "Terces Solutions — F&B Process & Technology Experts",
    homeDescription:
      "Terces Solutions is a restaurant consulting firm helping restaurants, cloud kitchens, and F&B chains across India and worldwide optimize operations, cut food costs, and scale profitably with measurable, guaranteed results.",
    keywords:
      "restaurant consulting India, food cost reduction, restaurant profitability, cloud kitchen consulting, F&B consulting, menu engineering",
    areaServed: "IN",
  },
};

export default globalConfig;
